import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import { ScheduledAppointment, ProceedingDetailProjection } from "./hearing-detail.models";

export interface ManagedHearingSchedulingBasis { requestId:number; scheduledProceedingId:number; workflowId:number; dueDate:string|null; currentReceiptId:number|null; basisIssue:string|null; }

const PROCEEDING_DETAIL_URL = "/api/v1/scheduling/projections/proceedings";

const quietHttpOptions = {
  headers: new HttpHeaders({
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
  }),
  withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class HearingDetailService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  getSchedulingBasis(requestId:number): Observable<ManagedHearingSchedulingBasis> {
    return this.http.get<ManagedHearingSchedulingBasis>(this.appConfig.apiUrl(`/api/phms/hearing-scheduling/requests/${requestId}`),quietHttpOptions);
  }

  getProceedingDetail(scheduledProceedingId: number): Observable<ProceedingDetailProjection> {
    // Absolute API host (apiUrl), not a relative path — the dev proxy's /api rule targets a stale
    // port and 500s relative calls. Mirrors the case-context services.
    return this.http.get<ProceedingDetailProjection>(
      this.appConfig.apiUrl(`${PROCEEDING_DETAIL_URL}/${encodeURIComponent(String(scheduledProceedingId))}`),
      quietHttpOptions,
    );
  }

  /**
   * Calendar-centric appointment for a scheduled proceeding: the same calendar projection row the grid
   * renders, plus the resolved incarceratedPersonId. Drives the flyout's calendar-first header and its
   * inline case-snapshot link in a single round-trip.
   */
  getAppointment(scheduledProceedingId: number): Observable<ScheduledAppointment> {
    return this.http.get<ScheduledAppointment>(
      this.appConfig.apiUrl(`${PROCEEDING_DETAIL_URL}/${encodeURIComponent(String(scheduledProceedingId))}/appointment`),
      quietHttpOptions,
    );
  }
}
